<template>
  <div class="form-group">
    <b-form-group
      label="E-mail do fiador"
      :label-for="fieldId('email')"
      class="mb-1"
    >
      <b-form-input
        :id="fieldId('email')"
        v-model="localValue.email"
        type="email"
        :class="{ 'is-invalid': hasText(localValue.email) && validateEmail(localValue.email) === false }"
        @blur="emitValue"
      />
      <div class="invalid-feedback">
        <span v-if="hasText(localValue.email) && validateEmail(localValue.email) === false">
          Você deve informar um e-mail válido
        </span>
      </div>
    </b-form-group>

    <b-row>
      <b-col cols="12">
        <h5 class="mb-1 mt-50">
          Dados pessoais
        </h5>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Nome completo"
          :label-for="fieldId('full-name')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('full-name')"
            v-model="localValue.full_name"
            maxlength="120"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Nacionalidade"
          :label-for="fieldId('nationality')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('nationality')"
            v-model="localValue.nationality"
            maxlength="60"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Estado civil"
          :label-for="fieldId('marital-status')"
          class="mb-1"
        >
          <v-select
            :id="fieldId('marital-status')"
            v-model="localValue.marital_status"
            :options="maritalStatusSelectOptions"
            :reduce="(status) => status.value"
            label="name"
            @input="emitValue"
          >
            <template #no-options>
              Sem resultados
            </template>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Profissão"
          :label-for="fieldId('profession')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('profession')"
            v-model="localValue.profession"
            maxlength="80"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <h5 class="mb-1 mt-50">
          Documentação
        </h5>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-form-group
          label="RG"
          :label-for="fieldId('rg')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('rg')"
            v-model="localValue.rg"
            maxlength="20"
            :class="{ 'is-invalid': hasText(localValue.rg) && rgIsValid(localValue.rg) === false }"
            @blur="emitValue"
          />
          <div class="invalid-feedback">
            <span v-if="hasText(localValue.rg) && rgIsValid(localValue.rg) === false">
              O RG informado é inválido
            </span>
          </div>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-form-group
          label="Órgão expedidor"
          :label-for="fieldId('issuing-agency')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('issuing-agency')"
            v-model="localValue.issuing_agency"
            maxlength="20"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-form-group
          label="CPF"
          :label-for="fieldId('cpf')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('cpf')"
            v-model="localValue.cpf"
            v-mask="'###.###.###-##'"
            maxlength="14"
            :class="{ 'is-invalid': hasText(localValue.cpf) && cpfIsValid(localValue.cpf) === false }"
            @blur="emitValue"
          />
          <div class="invalid-feedback">
            <span v-if="hasText(localValue.cpf) && cpfIsValid(localValue.cpf) === false">
              O CPF informado é inválido
            </span>
          </div>
        </b-form-group>
      </b-col>

      <b-col cols="12">
        <h5 class="mb-1 mt-50">
          Endereço
        </h5>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-form-group
          label="CEP"
          :label-for="fieldId('cep')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('cep')"
            v-model="localValue.cep"
            v-mask="'#####-###'"
            maxlength="9"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="8"
      >
        <b-form-group
          label="Endereço"
          :label-for="fieldId('address')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('address')"
            v-model="localValue.address"
            maxlength="150"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="3"
      >
        <b-form-group
          label="Número"
          :label-for="fieldId('number')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('number')"
            v-model="localValue.number"
            maxlength="20"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="5"
      >
        <b-form-group
          label="Complemento"
          :label-for="fieldId('complement')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('complement')"
            v-model="localValue.complement"
            maxlength="80"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="4"
      >
        <b-form-group
          label="Bairro"
          :label-for="fieldId('neighborhood')"
          class="mb-1"
        >
          <b-form-input
            :id="fieldId('neighborhood')"
            v-model="localValue.neighborhood"
            maxlength="80"
            @blur="emitValue"
          />
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Estado"
          :label-for="fieldId('state')"
          class="mb-1"
        >
          <v-select
            :id="fieldId('state')"
            v-model="localValue.address_state_id"
            :options="addressStates"
            :reduce="(addressState) => addressState.id"
            :loading="loadingAddressStates"
            :class="getSelectErrorClass(hasText(localValue.state) && !localValue.address_state_id)"
            label="name"
            @input="handleStateChange"
          >
            <template #no-options>
              Sem resultados
            </template>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col
        cols="12"
        md="6"
      >
        <b-form-group
          label="Município"
          :label-for="fieldId('city')"
          class="mb-1"
        >
          <v-select
            :id="fieldId('city')"
            v-model="localValue.address_city_id"
            :reduce="(city) => city.id"
            :options="cityOptions"
            :disabled="!localValue.address_state_id || cityLoading"
            :loading="cityLoading"
            :class="getSelectErrorClass(hasText(localValue.city) && !localValue.address_city_id)"
            label="name"
            @input="handleCityChange"
          >
            <template #no-options>
              Sem resultados
            </template>
          </v-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cpfIsValid from '@/validators/cpf'
import rgIsValid from '@/validators/rg'
import vSelect from 'vue-select'
import { getVueSelectErrorClass } from '@/helpers/validators'

export default {
  name: 'PromotionSignerInfoForm',
  components: {
    vSelect,
  },
  props: {
    value: { type: Object, required: true },
    itemId: { type: [Number, String], required: true },
    maritalStatusOptions: { type: Array, required: true },
    addressStates: { type: Array, default: () => [] },
    loadingAddressStates: { type: Boolean, default: false },
    cityOptions: { type: Array, default: () => [] },
    cityLoading: { type: Boolean, default: false },
  },
  data() {
    return {
      localValue: this.normalizeValue(this.value),
    }
  },
  computed: {
    maritalStatusSelectOptions() {
      return this.maritalStatusOptions
        .filter(option => option.value)
        .map(option => ({
          value: option.value,
          name: option.text,
        }))
    },
  },
  watch: {
    value: {
      deep: true,
      handler(newValue) {
        this.localValue = this.normalizeValue(newValue)
      },
    },
  },
  methods: {
    cpfIsValid,
    rgIsValid,
    getSelectErrorClass: getVueSelectErrorClass,

    fieldId(suffix) {
      return `promotion-signer-${this.itemId}-${suffix}`
    },

    hasText(value) {
      return String(value || '').trim() !== ''
    },

    validateEmail(email) {
      if (!email) return null
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    },

    normalizeValue(value) {
      return {
        email: '',
        full_name: '',
        nationality: '',
        marital_status: '',
        profession: '',
        rg: '',
        issuing_agency: '',
        cpf: '',
        address: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
        address_state_id: undefined,
        address_city_id: undefined,
        cep: '',
        ...(value || {}),
      }
    },

    getPayload() {
      return { ...this.localValue }
    },

    emitValue() {
      this.$emit('input', this.getPayload())
    },

    handleStateChange() {
      this.localValue.address_city_id = undefined
      this.localValue.city = ''
      this.emitValue()
      this.$emit('state-change', this.getPayload())
    },

    handleCityChange() {
      this.emitValue()
      this.$emit('city-change', this.getPayload())
    },
  },
}
</script>
